import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';
import { TextareaAutosize } from '@material-ui/core';
import { giftVoucherDialogStyles as styles } from './styles';

function GiftVoucherDialog({ onConfirm, onCancel, open, classes }) {
    const [buyingFor, setBuyingFor] = useState('me'); // 'me' lub 'someone'
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        confirmEmail: '',
        message: ''
    });
    const [errors, setErrors] = useState({});

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleBuyingChange = value => {
        setBuyingFor(value);
        setErrors({});
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Invalid email address';
        }
        if (!formData.confirmEmail.trim()) {
            newErrors.confirmEmail = 'Confirm email is required';
        } else if (formData.confirmEmail !== formData.email) {
            newErrors.confirmEmail = 'Email addresses do not match';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (buyingFor === 'someone') {
            if (validate()) {
                delete formData.buyingFor;
                onConfirm(formData);
            }
        } else {
            onConfirm();
        }
    };

    return (
        <Dialog
            open={!!open}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    margin: 0,
                    position: 'absolute',
                    top: '5vh',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            }}
        >
            <DialogContent>
                <DialogContentText className={classes.text} style={{ fontWeight: 'bold', marginTop: 30 }}>
                    Are you buying this gift voucher for you or someone else?
                </DialogContentText>

                <div style={{ display: 'flex', flexDirection: 'column', margin: '35px 20px 35px 20px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={buyingFor === 'me'}
                                onChange={() => handleBuyingChange('me')}
                                color="primary"
                            />
                        }
                        label="Buying for me"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={buyingFor === 'someone'}
                                onChange={() => handleBuyingChange('someone')}
                                color="primary"
                            />
                        }
                        label="Buying for someone else"
                    />
                </div>

                {buyingFor === 'someone' && (
                    <>
                        <DialogContentText className={classes.text} style={{ margin: '20px', textAlign: 'left' }}>
                            Enter the details of the person you are buying for and a personalised message.
                            <br />
                            You will also receive a confirmation of your purchase.
                        </DialogContentText>
                        <div style={{ margin: '0px 20px 20px' }}>
                            <TextField
                                fullWidth
                                label="Name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                                variant="outlined"
                                style={{ marginTop: 20 }}
                            />

                            <div className={classes.emailContainer}>
                                <TextField
                                    label="Email address"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    variant="outlined"
                                    fullWidth
                                />
                                <TextField
                                    label="Confirm email address"
                                    name="confirmEmail"
                                    type="email"
                                    value={formData.confirmEmail}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.confirmEmail}
                                    helperText={errors.confirmEmail}
                                    variant="outlined"
                                    fullWidth
                                />
                            </div>

                            <TextField
                                fullWidth
                                label="Message"
                                name="message"
                                multiline
                                value={formData.message}
                                onChange={handleChange}
                                error={!!errors.message}
                                helperText={errors.message}
                                variant="outlined"
                                style={{ marginTop: 20 }}
                                className={classes.customOutlinedRoot}
                                InputProps={{
                                    inputComponent: TextareaAutosize,
                                    inputProps: {
                                        minRows: 3,
                                        maxRows: 10,
                                        style: { resize: 'vertical', overflow: 'auto', maxHeight: 200 }
                                    }
                                }}
                            />
                        </div>
                    </>
                )}
                <DialogActions style={{ marginBottom: 30 }}>
                    <Button className={classes.button} onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button className={classes.button} onClick={handleSubmit}>
                        Continue
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

GiftVoucherDialog.propTypes = {
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(GiftVoucherDialog);
